import {ModalDialog, XmarkButton} from '@macmillanplatform/ui-core';
import {OnClickHandler} from '@macmillanplatform/ui-core/types';

import ContactsContent from '@/pages/contacts/components/contacts-content';

import './index.css';

interface ContactUsProps {
  show: boolean;
  toggle: OnClickHandler;
}

const ContactUs = (props: ContactUsProps) => {
  const {show, toggle} = props;

  return (
    <ModalDialog
      closeOnEsc
      overlayMode
      show={show}
      className="ContactUs__modal"
      onClose={toggle}
    >
      <div className="ContactUs__container">
        <div className="ContactUs__modal-header">
          <span className="ContactUs__modal-title">Contact Us</span>
          <XmarkButton className="ContactUs__title--close" onClick={toggle} />
        </div>
        <div className="ContactUs__modal-content">
          <ContactsContent />
        </div>
      </div>
    </ModalDialog>
  );
};

export default ContactUs;
